import { CircularProgress } from '@mui/material';
import { AuthBoxContainer } from '@/components/AuthBox';
import { useEffect } from 'react';
import { useGetCurrentUser } from '@/hooks/api/users/useGetCurrentUser';
import { useOidcAuth } from '@/services/auth';
import { useNavigate } from 'react-router-dom';

const OidcSignInPage = () => {
  const { login, isAuthenticated } = useOidcAuth();
  const { data: user, isLoading } = useGetCurrentUser({ skipRedirect: true, retry: false });
  const navigate = useNavigate();

  useEffect(() => {
    const isAuthorized = !!user?.user;
    if (isLoading) {
      return;
    }
    if (isAuthenticated && isAuthorized) {
      navigate('/tenants');
    } else {
      void login();
    }
  }, [isAuthenticated, user, isLoading]);

  return (
    <AuthBoxContainer>
      <CircularProgress size={24} sx={{ color: 'white' }} />
    </AuthBoxContainer>
  );
};

export default OidcSignInPage;
